import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ConfigFeatureKey, ConfigState } from "./market-config";

const PageConnfigState = createFeatureSelector<ConfigState>(ConfigFeatureKey);
export class MarketConfigSelector {
    static readonly marketConfig = createSelector(PageConnfigState, (state) => state.marketConfig);
    static readonly marketInfoConfig = createSelector(PageConnfigState, (state) => state.marketInfoConfig);
    static readonly warehouseConfig = createSelector(PageConnfigState, (state) => state.warehouseConfig);
}